import React, { useEffect, useState } from "react";
import styles from "./meetings.module.scss";
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Images from "assets/Images";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Datepicker from "components/minor/date-picker/date-picker";

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
    { title: 'Sahul Hameed' },
    { title: 'James hawkins' },
    { title: 'Sunil Basker' },
    { title: 'Mohan Kumar' },
    { title: 'Rakesh Sharma' },
    { title: "Sri Kanth" },
    { title: 'John Smith' }
];

const validationSchema = Yup.object({
    topic: Yup.string().required("Topic is required"),
    date: Yup.string().required("Date is required"),
    durationHr: Yup.string().required("Hour required"),
    durationMin: Yup.string().required("Minute required"),
    timezone: Yup.string().required("Timezone is required"),
    registration: Yup.boolean(),
    invitees: Yup.array().min(1, "Invitees is required"),
});
const ScheduleMeeting = ({ handleClose }) => {
    return (
        <>
            <div className={styles.headerContainer}>
                <h3>Schedule Meeting</h3>
            </div>

            <div className={styles.ScheduledMeetingForm}>
               
                <Formik
                    initialValues={{
                        topic: "",
                        date: "",
                        durationHr: "",
                        durationMin: "",
                        timezone: "(GMT + 530) India",
                        recurring: false,
                        invitees: [],
                        registration: false,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        console.log("Form Submitted ✅", values);
                        alert("Meeting scheduled successfully!");
                    }}
                >
                    {({ values, errors, touched, setFieldValue }) => (
                        <Form>
                            <div className={styles.formCont}>
                                <div className={styles.fromRow}>
                                    <label>Topic</label>

                                    <div className={`${styles.inlineFormFields} ${styles.flexCol}`}>
                                       <Field type="text" name="topic" className={styles.fluid}/>
                                        {touched.topic && errors.topic && (
                                            <div className={styles.error}>{errors.topic}</div>
                                        )}
                                    </div>
                                </div>
                                <div className={`${styles.fromRow}`}>
                                    <label>When</label>
                                    <div className={styles.inlineFormFieldsWrapper}>
                                        <div className={styles.inlineFormFields} >
                                            <Datepicker  name="date" label="Date" value={values.date || ''}
                                            onChange={(newValue) => setFieldValue("date", newValue)} />
                                            <select>
                                                <option>1:00</option>
                                                <option>1:30</option>
                                                <option>2:00</option>
                                                <option>2:30</option>
                                            </select>
                                            <select>
                                                <option>AM</option>
                                                <option>PM</option>
                                            </select>
                                        </div>
                                        {touched.date && errors.date && (
                                            <div className={styles.error} style={{ marginTop: '10px' }}>{errors.date}</div>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.fromRow}>
                                    <label>Duration</label>
                                    <div className={styles.inlineFormFields} name="durationHr">
                                        <select className={styles.w100}>
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                        </select>
                                        <p>hr</p>
                                        <select className={styles.w100} name="durationMin">
                                            <option>0</option>
                                            <option>15</option>
                                            <option>30</option>
                                            <option>45</option>
                                        </select>
                                        <p>min</p>
                                    </div>
                                </div>

                                <div className={styles.fromRow}>
                                    <label>Time Zone</label>
                                    <div className={styles.inlineFormFields}>
                                        <select className={styles.fluid} name="timezone" >
                                            <option>(GMT + 530) India</option>
                                        </select>
                                    </div>
                                </div>

                                <div className={`${styles.fromRow} ${styles.flexRow}`}>
                                    <label>Recurring Meeting</label>
                                    <div className={styles.inlineFormFields}>
                                        <input type="checkbox" name="recurring" />
                                    </div>
                                </div>

                                <div className={styles.fromRow}>
                                    <label>Invitees</label>
                                    <div className={styles.inlineFormFields}>

                                        <Autocomplete
                                            multiple
                                            limitTags={2}
                                            id="multiple-limit-tags"
                                            options={top100Films}
                                            getOptionLabel={(option) => option.title}
                                            value={values.invitees}
                                            onChange={(event, newValue) => setFieldValue("invitees", newValue)}
                                            // defaultValue={[top100Films[13], top100Films[12], top100Films[11]]}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    name="invitees"
                                                    placeholder="Search Meeting Members"
                                                    error={touched.invitees && Boolean(errors.invitees)}
                                                    helperText={touched.invitees && errors.invitees}
                                                    FormHelperTextProps={{
                                                        sx: {
                                                            marginLeft: 0
                                                        }
                                                    }}
                                                   
                                                />
                                            )}
                                        />

                                    </div>
                                </div>

                                <div className={`${styles.fromRow} ${styles.flexRow}`}>
                                    <label>Registration</label>
                                    <div className={styles.inlineFormFields} name="registration">
                                        <input type="checkbox" /> Required
                                    </div>
                                </div>
                                <div className={styles.btnContainer}>
                                    <button onClick={handleClose} className={styles.btnBordered}>Cancel</button>
                                    <button className={styles.btnPrimary}>Save</button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
};

export default ScheduleMeeting;
